module.exports = __webpack_public_path__ + "img/banner.ec23a27d.png";